export const cookieBannerGrouping = {
  title: {section: 'cookie_banner', subsection: 'cookie_banner'},
  text: {section: 'cookie_banner', subsection: 'cookie_banner'},
  button_accept_text: {section: 'cookie_banner', subsection: 'cookie_banner'},
  button_decline_text: {section: 'cookie_banner', subsection: 'cookie_banner'},
  button_prefs_open_text: {
    section: 'cookie_banner',
    subsection: 'cookie_banner',
  },
  policy_link_text: {section: 'cookie_banner', subsection: 'cookie_banner'},
  policy_link_url: {section: 'cookie_banner', subsection: 'cookie_banner'},

  preferences_title: {section: 'cookie_preferences', subsection: 'header'},
  preferences_button_accept_text: {
    section: 'cookie_preferences',
    subsection: 'header',
  },
  preferences_button_decline_text: {
    section: 'cookie_preferences',
    subsection: 'header',
  },
  preferences_button_save_text: {
    section: 'cookie_preferences',
    subsection: 'header',
  },

  preferences_intro_title: {
    section: 'cookie_preferences',
    subsection: 'introduction',
  },
  preferences_intro_text: {
    section: 'cookie_preferences',
    subsection: 'introduction',
  },

  preferences_bullet_points_title: {
    section: 'cookie_preferences',
    subsection: 'bullet_point_summary',
  },
  preferences_bullet_points_first_text: {
    section: 'cookie_preferences',
    subsection: 'bullet_point_summary',
  },
  preferences_bullet_points_second_text: {
    section: 'cookie_preferences',
    subsection: 'bullet_point_summary',
  },
  preferences_bullet_points_third_text: {
    section: 'cookie_preferences',
    subsection: 'bullet_point_summary',
  },

  preferences_purposes_essential_name: {
    section: 'cookie_preferences',
    subsection: 'cookie_checkboxes',
  },
  preferences_purposes_essential_desc: {
    section: 'cookie_preferences',
    subsection: 'cookie_checkboxes',
  },
  preferences_purposes_performance_name: {
    section: 'cookie_preferences',
    subsection: 'cookie_checkboxes',
  },
  preferences_purposes_performance_desc: {
    section: 'cookie_preferences',
    subsection: 'cookie_checkboxes',
  },
  preferences_purposes_preferences_name: {
    section: 'cookie_preferences',
    subsection: 'cookie_checkboxes',
  },
  preferences_purposes_preferences_desc: {
    section: 'cookie_preferences',
    subsection: 'cookie_checkboxes',
  },
  preferences_purposes_marketing_name: {
    section: 'cookie_preferences',
    subsection: 'cookie_checkboxes',
  },
  preferences_purposes_marketing_desc: {
    section: 'cookie_preferences',
    subsection: 'cookie_checkboxes',
  },
};
